<app-date-selection-filter
  [timescale]="filters.timescale.value"
  [startDate]="filters.startDate.value"
  (change)="filterChanged('startDate', $event.value)"
  groupPosition="last"
  [setDatePickerValues]="setDatePickerValues"
  [alertSpecificData]="alertSpecificData"
></app-date-selection-filter>
